var _path, _ellipse, _mask, _path2, _path3, _path4, _path5, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 987,
    viewBox: "0 0 1440 987",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M898.5 554C898.5 583.938 878.817 611.279 846.492 631.212C814.191 651.131 769.473 663.5 720 663.5C670.527 663.5 625.809 651.131 593.508 631.212C561.183 611.279 541.5 583.938 541.5 554C541.5 524.062 561.183 496.721 593.508 476.788C625.809 456.869 670.527 444.5 720 444.5C769.473 444.5 814.191 456.869 846.492 476.788C878.817 496.721 898.5 524.062 898.5 554Z",
    stroke: "white",
    strokeWidth: 3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    rx: 23,
    ry: 14,
    transform: "matrix(1 0 0 -1 720 554)",
    fill: "white",
    fillOpacity: 0.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1_166_776",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M822 142.5C822 155.893 811.254 168.738 792.125 178.209C772.996 187.679 747.052 193 720 193C692.948 193 667.004 187.679 647.875 178.209C628.746 168.738 618 155.893 618 142.5L720 142.5H822Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M822 142.5C822 155.893 811.254 168.738 792.125 178.209C772.996 187.679 747.052 193 720 193C692.948 193 667.004 187.679 647.875 178.209C628.746 168.738 618 155.893 618 142.5L720 142.5H822Z",
    stroke: "white",
    strokeWidth: 6,
    mask: "url(#path-3-inside-1_166_776)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M395.49 143.5L436.131 1.5H1007.87L1048.51 143.5H395.49Z",
    stroke: "white",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M572.97 56.5L588.142 1.5H851.858L867.03 56.5H572.97Z",
    stroke: "white",
    strokeWidth: 3
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-130.311 1038L271.028 1.5H1168.97L1563.32 1038H-130.311Z",
    stroke: "white",
    strokeWidth: 3
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 58,
    y1: 552.5,
    x2: 1378,
    y2: 552.5,
    stroke: "white",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup5);
export default __webpack_public_path__ + "static/media/Group_5.fa330143e99922e4e85b013a1fa98fa4.svg";
export { ForwardRef as ReactComponent };